@let inv = invoice();
@let invoiceNumber = inv?.invoiceNumber;
@let headingWithNumber = 'Rechnung {{number}}' | translate: { number: invoiceNumber };
@let headingWithoutNumber = 'Rechnung' | translate;
<base-site-layout
    [heading]="invoiceNumber ? headingWithNumber : headingWithoutNumber"
    [actions]="inv ? actions : null"
    [stickyActions]="!!inv"
    headerIcon="iim iim-invoice"
>
    <ng-template #actions>
        <div class="d-flex justify-content-end gap-2 flex-wrap">
            @if (invoice() && hasPdfFileAttachments()) {
                <button class="btn btn-outline-dark" *showOnDesktop (click)="togglePdfPreview()">
                    @if (showPdfPreview()) {
                        <em class="fas fa-eye-slash pe-1"></em>
                        {{ 'PDF Vorschau ausblenden' | translate }}
                    } @else {
                        <em class="fas fa-eye pe-1"></em>
                        {{ 'PDF Vorschau anzeigen' | translate }}
                    }
                </button>
            }

            @if (markAsPaidAllowed()) {
                <button class="btn btn-primary" (click)="onMarkInvoiceAsPaid()">
                    <em class="fas fa-euro-sign pe-1"></em>
                    {{ 'Rechnung als bezahlt markieren' | translate }}
                </button>
            }

            @if (editAllowed()) {
                <button class="btn btn-primary" (click)="onEditInvoice()">
                    <em class="fas fa-pen pe-1"></em>
                    {{ 'Rechnung bearbeiten' | translate }}
                </button>
            }
        </div>
    </ng-template>

    @if (inv) {
        <div class="row">
            @if (showPdfPreview()) {
                <div class="col-12 col-lg-6">
                    <invoice-detail
                        [invoice]="inv"
                        [forceMobileLayout]="showPdfPreview()"
                        (filesChanged)="filesChanged($event)"
                    ></invoice-detail>
                </div>
                <div class="col-12 col-lg-6" *showOnDesktop>
                    <div class="pdf-sticky-wrapper">
                        @if (pdfSideBySide.isOpen()) {
                            <document-pdf-side-by-side></document-pdf-side-by-side>
                        } @else {
                            <pdf-preview [files]="invoiceFiles()"></pdf-preview>
                        }
                    </div>
                </div>
            } @else {
                <div class="col">
                    <invoice-detail
                        [invoice]="inv"
                        [forceMobileLayout]="false"
                        (filesChanged)="filesChanged($event)"
                    ></invoice-detail>
                </div>
            }
        </div>
    } @else if (hasLoadError()) {
        @let status = loadError();
        <div class="container py-5">
            <div class="row justify-content-center">
                <div class="col-xl-7 col-lg-8 col-md-10">
                    <div class="invoice-load-error text-center">
                        <div class="invoice-load-error__icon text-danger mb-3">
                            <em class="fas fa-circle-xmark fa-4x"></em>
                        </div>
                        <p class="fw-bold mb-1">
                            {{ 'Die Rechnung konnte nicht geladen werden.' | translate }}
                        </p>
                        <p class="mb-0 text-muted">
                            @if (status === 400) {
                                {{ 'Die Anfrage ist ungültig. Bitte prüfen Sie die URL.' | translate }}
                            } @else if (status === 403) {
                                {{ 'Sie haben keine Berechtigung diese Rechnung zu sehen.' | translate }}
                            } @else if (status === 404) {
                                {{ 'Die Rechnung wurde nicht gefunden.' | translate }}
                            } @else if (status === 500) {
                                {{
                                    'Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
                                        | translate
                                }}
                            } @else {
                                {{
                                    'Entweder sie existiert nicht, oder Sie haben keine Berechtigungen sie zu sehen.'
                                        | translate
                                }}
                            }
                        </p>
                        <div class="mt-4 d-flex justify-content-center">
                            <button type="button" class="btn btn-primary" routerLink="/client/my-admin/invoice/list">
                                <em class="fas fa-arrow-left me-2"></em>
                                {{ 'Gehe zur Rechnungsliste' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } @else if (isLoading()) {
        <document-layout [isLoading]="true"></document-layout>
    }
</base-site-layout>
